import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const registerInstaller = (values) =>
  Manager.client().post(Endpoints.auth.registerIntastaller, values);
const registerCustomer = (values) =>
  Manager.client().post(Endpoints.auth.registerCustomer, values);

export const Request = {
  registerInstaller,
  registerCustomer,
};
